export default __webpack_public_path__ + "asset/slipUp-720281672f2d96a5150408c4950d92b5.png";